(() => {
  if (customElements.get('dalji-black-campaign')) return;
  const duration = (ms) => {
    const seconds = Math.max(0, Math.floor(ms / 1000));
    const days = Math.floor(seconds / 86400);
    const time = [Math.floor(seconds % 86400 / 3600), Math.floor(seconds % 3600 / 60), seconds % 60]
      .map(value => String(value).padStart(2, '0')).join(':');
    return `${days ? `${days}d ` : ''}${time}`;
  };
  class DaljiBlackCampaign extends HTMLElement {
    static select(offers, now) {
      const valid = offers.filter(o => o.enabled && o.handle && Number.isFinite(o.start) && Number.isFinite(o.end) && o.end > o.start)
        .sort((a, b) => a.start - b.start);
      const overlap = valid.some((o, i) => i > 0 && valid.slice(0, i).some(p => p.end > o.start));
      // Keep a usable offer visible even when another block overlaps. Latest start wins.
      const live = [...valid].reverse().find(o => now >= o.start && now < o.end);
      return { offer: live || valid.find(o => o.start > now) || null, active: Boolean(live), overlap, ended: valid.length > 0 && valid.every(o => now >= o.end) };
    }
    connectedCallback() {
      this.abort?.abort();
      this.abort = new AbortController();
      const options = { signal: this.abort.signal };
      this.offers = [...this.querySelectorAll('[data-offer]')].map(node => ({
        node, enabled: node.dataset.enabled === 'true', handle: node.dataset.handle,
        start: this.parseDate(node.dataset.start), end: this.parseDate(node.dataset.end)
      }));
      const testTime = this.dataset.editor === 'true' ? Date.parse(this.dataset.testNow) : NaN;
      this.offset = Number.isFinite(testTime) ? testTime - Date.now() : 0;
      this.current = null;
      this.refreshAt = 0;
      this.querySelectorAll('[data-refresh]').forEach(button => button.addEventListener('click', () => {
        if (this.current?.active) this.loadPrice(this.current.offer);
      }, options));
      document.addEventListener('visibilitychange', () => { if (!document.hidden) this.tick(true); }, options);
      window.addEventListener('pageshow', () => this.tick(true), options);
      this.tick();
      this.interval = window.setInterval(() => this.tick(), 1000);
    }
    disconnectedCallback() {
      clearInterval(this.interval);
      this.abort?.abort();
      this.priceAbort?.abort();
    }
    parseDate(value) {
      if (!/^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:00-03:00$/.test(value || '')) return NaN;
      const time = Date.parse(value);
      // Reject impossible calendar dates instead of silently rolling into another month.
      return Number.isFinite(time) && new Date(time - 10800000).toISOString().slice(0, 19) === value.slice(0, 19) ? time : NaN;
    }
    renderSuspense(offer, now) {
      const node = offer.node;
            const hour = Number(new Intl.DateTimeFormat('en-GB', { timeZone: 'America/Sao_Paulo', hour: '2-digit', hourCycle: 'h23' }).format(offer.start));
            const time = new Intl.DateTimeFormat('pt-BR', { timeZone: 'America/Sao_Paulo', hour: '2-digit', minute: '2-digit', hourCycle: 'h23' }).format(offer.start);
            const shortTime = time.endsWith(':00') ? `${Number(time.slice(0, 2))}h` : time.replace(':', 'h');
            node.querySelector('[data-next-title]').textContent = hour < 15 ? (this.dataset.suspenseDayTitle || 'O próximo segredo está prestes a ser revelado') : (this.dataset.suspenseEveningTitle || 'O próximo desconto surpresa começa em breve.');
            const description = node.querySelector('[data-suspense-duration]');
            if (description) description.textContent = `Prepare-se: oferta válida por pouco tempo ou enquanto durar o estoque.`;
            const comeback = node.querySelector('[data-suspense-return]');
            const startDay = new Intl.DateTimeFormat('en-CA', { timeZone: 'America/Sao_Paulo' }).format(offer.start);
            const today = new Intl.DateTimeFormat('en-CA', { timeZone: 'America/Sao_Paulo' }).format(now);
            const date = new Intl.DateTimeFormat('pt-BR', { timeZone: 'America/Sao_Paulo', day: '2-digit', month: '2-digit' }).format(offer.start);
            if (comeback) comeback.textContent = startDay === today ? `Volte às ${shortTime}` : `Volte em ${date}, às ${shortTime}`;
            const link = node.querySelector('[data-reminder]');
            const phone = (this.dataset.reminderPhone || '').replace(/\D/g, '');
            if (link && phone) {

              const label = node.querySelector('[data-reminder-label]');
              const hint = node.querySelector('[data-reminder-hint]');
              if (label) label.textContent = 'Me avise';
              if (hint) hint.textContent = 'Não perca a abertura. Clique em “Me avise” e receba o aviso no seu WhatsApp.';

              const message = "Quero receber neste WhatsApp os avisos das ofertas-relâmpago da Black Week e também novidades, lançamentos e ofertas da Dalji. Posso cancelar a qualquer momento enviando SAIR.";
              link.href = `https://wa.me/${phone}?text=${encodeURIComponent(message)}`;
            }
    }
    tick(forcePrice = false) {
      const now = Date.now() + this.offset;
      const state = DaljiBlackCampaign.select(this.offers, now);
      const changed = this.current?.offer !== state.offer || this.current?.active !== state.active;
      if (changed || !this.current) {
        this.priceAbort?.abort();
        this.loadingPrice = false;
        this.offers.forEach(o => { o.node.hidden = o !== state.offer; });
        this.current = state;
        this.querySelector('[data-empty]').hidden = Boolean(state.offer);
        if (state.offer) {
          const node = state.offer.node;
          node.dataset.state = state.active ? 'live' : 'next';
          node.querySelector('[data-next-media]').hidden = state.active;
          node.querySelector('[data-next-title]').hidden = state.active;
          node.querySelector('[data-live-media]').hidden = !state.active;
          node.querySelectorAll('[data-live-details]').forEach(details => { details.hidden = !state.active; });
          node.querySelector('[data-timer-label]').textContent = state.active ? 'Preço especial por apenas:' : 'Sua chance começa em:';
          node.querySelectorAll('[data-next-copy]').forEach(copy => { copy.hidden = state.active; });
          const eyebrow = node.querySelector('[data-offer-eyebrow]');
          if (eyebrow) eyebrow.textContent = state.active ? 'OFERTA-RELÂMPAGO · LIBERADA' : 'OFERTA-RELÂMPAGO · BLACK WEEK';
          node.querySelector('[data-schedule]').textContent = new Intl.DateTimeFormat('pt-BR', {
            timeZone: 'America/Sao_Paulo', day: '2-digit', month: '2-digit', year: 'numeric', hour: '2-digit', minute: '2-digit'
          }).format(state.offer.start) + ' · horário de Brasília';
        }
      }
      this.querySelector('[data-status]').textContent = state.offer ? (state.active ? 'Oferta liberada' : 'Próxima oferta') : 'Sem ofertas programadas';
      const warning = this.querySelector('[data-validation]');
      if (warning) {
        const invalid = this.offers.filter(o => o.enabled && (!o.handle || !Number.isFinite(o.start) || !Number.isFinite(o.end) || o.end <= o.start));
        warning.hidden = !invalid.length && !state.overlap;
        warning.textContent = state.overlap ? 'Existem ofertas com horários sobrepostos. Revise os blocos. Enquanto houver coincidência, aparece a oferta com o início mais recente.' : `${invalid.length} oferta(s) ativa(s) sem produto ou com data/horário inválido. Revise os blocos.`;
      }
      if (!state.offer) {
        const empty = this.querySelector('[data-empty]');
        const title = empty.querySelector('[data-empty-title]');
        const text = empty.querySelector('[data-empty-text]');
        if (title) title.textContent = state.ended ? empty.dataset.endedTitle : 'Nenhuma oferta configurada para exibição';
        if (text) text.textContent = state.ended ? empty.dataset.endedText : 'As próximas ofertas serão anunciadas aqui.';
        return;
      }
      if (!state.active) this.renderSuspense(state.offer, now);
      const remaining = (state.active ? state.offer.end : state.offer.start) - now;
      const timer = state.offer.node.querySelector('[data-timer]');
      const seconds = Math.max(0, Math.floor(remaining / 1000));
      const values = { days: Math.floor(seconds / 86400), hours: Math.floor(seconds % 86400 / 3600), minutes: Math.floor(seconds % 3600 / 60), seconds: seconds % 60 };
      const units = timer.querySelectorAll('[data-unit]');
      if (units.length) units.forEach(unit => { unit.textContent = String(values[unit.dataset.unit]).padStart(2, '0'); if (unit.dataset.unit === 'days') unit.parentElement.hidden = values.days === 0; });
      else timer.textContent = duration(remaining);
      if (state.active && !this.loadingPrice && (changed || forcePrice || Date.now() >= this.refreshAt)) this.loadPrice(state.offer);
    }
    async loadPrice(offer) {
      if (!this.current?.active || this.current.offer !== offer) return;
      this.priceAbort?.abort();
      const controller = new AbortController();
      this.priceAbort = controller;
      this.loadingPrice = true;
      this.refreshAt = Date.now() + 30000;
      const node = offer.node;
      const price = node.querySelector('[data-price]');
      const status = node.querySelector('[data-price-status]');
      const action = node.querySelector('[data-action]');
      const refresh = node.querySelector('[data-refresh]');
      const compare = node.querySelector('[data-compare]');
      const percent = node.querySelector('[data-percent]');
      const installment = node.querySelector('[data-installment]');
      const badge = node.querySelector('[data-badge]');
      const unlocked = node.querySelector('[data-discount-unlocked]');
      const pixLabel = node.querySelector('[data-pix-label]');
      [compare, percent, installment, badge, unlocked, pixLabel].forEach(element => { if (element) element.hidden = true; });
      price.textContent = '';
      status.textContent = 'Consultando preço e disponibilidade…';
      action.hidden = true;
      refresh.hidden = true;
      const timeout = setTimeout(() => controller.abort(), 10000);
      try {
        const response = await fetch(`${this.dataset.root || '/'}products/${encodeURIComponent(offer.handle)}.js`, { cache: 'no-store', signal: controller.signal });
        if (!response.ok) throw new Error('product unavailable');
        const product = await response.json();
        if (this.current?.offer !== offer || !this.current.active) return;
        const now = Date.now() + this.offset;
        if (now < offer.start || now >= offer.end) { this.tick(); return; }
        const available = (product.variants || []).filter(variant => variant.available);
        if (!available.length) {
          node.querySelector('[data-badge]').textContent = 'ESGOTADO';
          node.querySelector('[data-badge]').hidden = false;
          status.textContent = '';
          node.dataset.stock = 'soldout';
          return;
        }
        node.dataset.stock = 'available';
        const values = available.map(variant => Number(variant.price)).filter(Number.isFinite);
        if (!values.length) throw new Error('invalid price');
        const minimum = Math.min(...values);
        const varies = new Set(values).size > 1;
        const from = varies ? 'A partir de ' : '';
        const format = cents => new Intl.NumberFormat(this.dataset.locale || 'pt-BR', { style: 'currency', currency: this.dataset.currency || 'BRL' }).format(cents / 100);
        const lowestVariant = available.find(variant => Number(variant.price) === minimum);
        const oldPrice = Number(lowestVariant?.compare_at_price);
        const onSale = oldPrice > minimum;
        const plannedNote = node.querySelector('[data-planned-note]');
        const plannedDiscount = Number(node.dataset.plannedDiscount) || 0;
        if (plannedNote) {
          const actualDiscount = onSale ? Math.round((oldPrice - minimum) * 100 / oldPrice) : 0;
          plannedNote.hidden = !plannedDiscount || actualDiscount === plannedDiscount;
          plannedNote.textContent = `Programado: ${plannedDiscount}% de desconto. Preço atual do produto: ${actualDiscount}%. Confira o Shopify/Boomr. O Pix é calculado separadamente.`;
        }
        const isBRL = (this.dataset.currency || 'BRL') === 'BRL';
        const pixPercent = Math.min(100, Math.max(0, Number(this.dataset.pixDiscount) || 0));
        const pixEligible = isBRL && node.dataset.giftCard !== 'true' && pixPercent > 0 && (!onSale || this.dataset.pixOnSale !== 'false');
        const pixAmount = pixEligible ? minimum - Math.floor(minimum * pixPercent / 100) : minimum;
        price.textContent = from + format(pixAmount);
        if (pixLabel && pixEligible) {
          pixLabel.textContent = 'à vista no Pix';
          pixLabel.hidden = false;
        }
        if (unlocked) unlocked.hidden = !(onSale || pixEligible);
        if (compare && percent && oldPrice > minimum) {
          compare.textContent = format(oldPrice); compare.hidden = false;
          const discount = Math.round((oldPrice - minimum) * 100 / oldPrice);
          percent.textContent = `${discount}% OFF`; percent.hidden = discount < 1;
          percent.title = 'Desconto do produto antes do desconto adicional do Pix.';
        }
        const configuredCount = Math.min(12, Math.max(0, Math.floor(Number(this.dataset.installments) || 0)));
        const minimumPart = Math.max(0, Number(this.dataset.minimumInstallment) || 0) * 100;
        const count = minimumPart ? Math.min(configuredCount, Math.floor(minimum / minimumPart)) : configuredCount;
        if (installment && isBRL && node.dataset.giftCard !== 'true' && (count > 1 || pixEligible)) {
          const plan = count > 1 ? `${count}x de ${format(Math.round(minimum / count))} sem juros` : '';
          installment.textContent = plan ? `ou ${varies ? 'a partir de ' : ''}${plan}` : `ou ${format(minimum)} no cartão`;
          installment.hidden = false;
        }
        status.textContent = '';
        action.textContent = (onSale || pixEligible) ? (node.dataset.actionLabel || 'COMPRAR COM DESCONTO') : 'Ver produto';
        action.hidden = false;
        refresh.hidden = true;
      } catch (error) {
        if (this.current?.offer !== offer || !this.current.active) return;
        const now = Date.now() + this.offset;
        if (now < offer.start || now >= offer.end) { this.tick(); return; }
        status.textContent = 'Consulte o preço e a disponibilidade na página do produto.';
        action.textContent = 'Ver produto';
        action.hidden = node.dataset.stock === 'soldout';
        if (badge && node.dataset.stock === 'soldout') badge.hidden = false;
        refresh.hidden = false;
      } finally {
        clearTimeout(timeout);
        if (this.priceAbort === controller) this.loadingPrice = false;
      }
    }
  }
  customElements.define('dalji-black-campaign', DaljiBlackCampaign);
})();
